import useSearchParams from 'hooks/useSearchParams'
import * as React from 'react'

import PreviewDocument from './PreviewDocument'
import PreviewForm from './PreviewForm'

const PreviewViewer = (): React.Node => {
  const searchParams = useSearchParams()
  const isForm = searchParams.get('response_type') === 'form'

  if (isForm) return <PreviewForm />
  return <PreviewDocument />
}

export default PreviewViewer
